import React from "react";
import { SlLocationPin } from "react-icons/sl";
// import { MdEmail } from "react-icons/md";
import { IoMail } from "react-icons/io5";
import { FaPhoneAlt, FaYoutube } from "react-icons/fa";
import { ImFacebook2 } from "react-icons/im";
import { FaLocationArrow } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import { ContactData } from "../data-types/api-client/api-contacts";
interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const Footer: React.FC<ContactProps> = ({ contact }) => {
  const navigate = useNavigate();

  if (!contact) {
    return null; // Handle null contact state
  }
  return (
    <footer className="border-t border-bg-custom-blue text-custom-atrament p-6 flex md:flex-row flex-col w-full flex-wrap xl:gap-12">
      <div className="md:min-w-[15rem] md:max-w-[20rem] md:flex-1 m-4">
        <h3 className="font-semibold text-center md:text-left font-exo md:mb-4 mb-2 uppercase md:text-xl text-base lg:text-xl">
          Rentkos s.r.o.
        </h3>
        <div className="pl-2 border-l-4 border-custom-red text-center md:text-left text-sm md:text-base">
          <p className="mb-4">
            Spoločnosť RENTKOS s.r.o. je novou spoločnosť, zameranou na prenájom
            stavebného náradia, malej mechanizácie a čistiacej techniky.
          </p>
          <p>
            V našom sortimente nájdu pre seba potrebné náradie a mechanizáciu
            domáci majstri, ako aj profesionáli v oblasti stavebníctva.
          </p>
        </div>
      </div>
      <div className="md:min-w-[15rem] md:max-w-[20rem] m-4 text-center md:text-left">
        <h3 className="font-semibold font-exo md:mb-4 mb-2 md:text-xl text-base lg:text-xl">
          Čo požičiavame
        </h3>
        <div
          className="font-roboto flex flex-col md:gap-2 gap-1 text-sm md:text-base hover:text-custom-mustard hover:cursor-pointer  
             transition duration-200 ease-in-out"
          onClick={() => navigate("/prenajom-zariadeni")}
        >
          <p>Ručné náradie</p>
          <p>Malá mechanizácia</p>
          <p>Energie, kúrenie</p>
        </div>
      </div>
      <div className=" md:min-w-[15rem] md:max-w-[20rem] m-4 flex flex-col">
        <h3 className="font-semibold font-exo md:mb-4 mb-2 md:text-xl text-base lg:text-xl text-center md:text-left">
          Adresa predajne
        </h3>
        <div className="flex flex-col text-sm md:text-base justify-center gap-2">
          <div className="flex items-start justify-center md:justify-start gap-1 ">
            <SlLocationPin className="text-custom-atrament lg:text-xl text-xl" />
            <div className="flex flex-col gap-2 text-center md:text-left">
              <p>{contact.contact.address.name}</p>
              <p>
                {" "}
                {`${contact?.contact.address.street} ${contact?.contact.address.number}`}
              </p>
              <p>
                {contact?.contact.address.psc}{" "}
                {contact?.contact.address.village}
              </p>
            </div>
          </div>
          <span
            className="flex justify-center md:justify-start group hover:cursor-pointer  
             transition duration-200 ease-in-out"
          >
            {" "}
            <a
              className="flex md:items-start items-center justify-center md:justify-start group-hover:text-custom-mustard 
              "
              href={`${contact?.contact.address.dispensingPointGoogleMapsUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLocationArrow className="text-custom-red group-hover:text-custom-mustard mr-2 lg:text-xl text-xl" />
              <p className="text-center md:text-left">
                {`Výdajné miesto: ${contact?.contact.address.dispensingPoint} ${contact?.contact.address.dispensingPointDetails}`}
              </p>
            </a>
          </span>
        </div>
      </div>
      <div className=" md:min-w-[15rem] md:max-w-[20rem] m-4">
        <h3 className="font-semibold font-exo mb-2 md:mb-4 md:text-xl text-base lg:text-xl text-center md:text-left">
          Kontakt
        </h3>
        <div className="text-sm md:text-base">
          <div className="lg:mb-4 mb-2 flex flex-col gap-1">
            <p className="text-center md:text-left uppercase">Infolinka:</p>
            <span
              className="flex justify-center md:justify-start group hover:cursor-pointer  
             transition duration-200 ease-in-out"
            >
              <a
                href={`tel:${contact?.contact.mobileConsultancy}`}
                className="flex items-center group-hover:text-custom-mustard"
              >
                <FaPhoneAlt className="mr-2 text-lg" />
                {contact?.contact.mobileConsultancy}
              </a>
            </span>
          </div>
          <div>
            <span
              className="flex justify-center md:justify-start group hover:cursor-pointer  
             transition duration-200 ease-in-out"
            >
              <a
                href={`mailto:${contact?.contact.email}`}
                className="flex items-center group-hover:text-custom-mustard"
              >
                <IoMail className="mr-2 text-lg" />
                {contact?.contact.email}
              </a>
            </span>
          </div>
          {contact?.contact.facebookUrl && (
            <div className="lg:mt-4 mt-2">
              <span
                className="flex justify-center md:justify-start group hover:cursor-pointer  
             transition duration-200 ease-in-out"
              >
                <a
                  href={`${contact?.contact.facebookUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center group-hover:text-custom-mustard"
                >
                  <ImFacebook2 className="mr-2 text-lg" />
                  Facebook
                </a>
              </span>
            </div>
          )}

          {contact?.contact.youtubeUrl && (
            <div className="lg:mt-4 mt-2">
              <span className="flex justify-center md:justify-start group hover:text-custom-mustard">
                <a
                  href={`${contact?.contact.youtubeUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center"
                >
                  <FaYoutube className="mr-2 group-hover:text-custom-mustard g:text-xl text-lg" />
                  Youtube
                </a>
              </span>
            </div>
          )}
        </div>
      </div>
      <div
        className="
      md:min-w-[15rem] md:max-w-[20rem] m-4"
      >
        <h3 className="font-semibold font-exo lg:mb-4 mb-2 md:text-xl text-base lg:text-xl text-center md:text-left">
          Otváracie hodiny
        </h3>
        <div className="text-sm md:text-base text-center md:text-left">
          {contact?.contact.address.openingHours.map((hour) => (
            <p className="md:mt-2 mt-1 lg:mb-2 mb-1">{hour.item}</p>
          ))}
        </div>
      </div>
      <div
        className="
      md:min-w-[15rem] md:max-w-[20rem] m-4 flex flex-col"
      >
        <h3 className="font-semibold font-exo lg:mb-4 mb-2 md:text-xl text-base lg:text-xl text-center md:text-left">
          Ochrana súkromia
        </h3>
        <div className="text-center md:text-left text-sm md:text-base flex flex-col">
          <span className="flex justify-center md:justify-start hover:text-custom-mustard">
            <Link to="/sukromie">Osobné údaje a Cookies</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
